// extracted by mini-css-extract-plugin
export default {"description":"ForBusinesses_description__FzeQb","container":"ForBusinesses_container__OwUO6"};